export default __webpack_public_path__ + "static/media/ct1.1.c6e2e42b.png";